module.exports = __webpack_public_path__ + "assets/images/user-emerald.svg?6d5f474c4cfce730e9906e03313f4d08";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/user-emerald.svg
// module id = 25
// module chunks = 0